import { ref } from 'vue'

import type { RowInfoProps } from '../types/interfaces'

interface RowInfoReturn {
  refIsCopied: Ref<boolean>
  setCopy: () => void
}

export const useRowInfo = (props: RowInfoProps): RowInfoReturn => {
  const refIsCopied = ref<boolean>(false)

  const setCopy = (): void => {
    const body = props.linkUrl ?? props.value

    if (!body) return

    navigator.clipboard.writeText(body)
    refIsCopied.value = true

    setTimeout(() => {
      refIsCopied.value = false
    }, 2000)
  }

  return {
    refIsCopied,
    setCopy,
  }
}
